module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-en-US.0f0525cc.jpg";